import DNAComplementMap from "./DNAComplementMap";
export default function getReverseComplementSequenceString(sequence) {
  let reverseComplementSequenceString = "";
  for (let i = sequence.length - 1; i >= 0; i--) {
    let revChar = DNAComplementMap[sequence[i]];
    if (!revChar) {
      revChar = sequence[i];
    }
    reverseComplementSequenceString += revChar;
  }
  return reverseComplementSequenceString;
}
